import React, { PureComponent, Fragment } from 'react';
import { I18n } from 'aws-amplify';
import WhatifWrapper from '../components/WhatifWrapper';

import SubHeader from '../components/SubHeader';

import PageSuccess from '../components/PageSuccess';

class BrandeProfileSuccess extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <WhatifWrapper>
                <SubHeader />
                <PageSuccess>
                    <Fragment>
                        <h2>Tudo certo!</h2>
                        <p>Seu direcionamento foi cadastrado com sucesso, você será notificado quando forem enviadas conteúdos ou idéias dentro do perfil definido.</p>
                    </Fragment>
                </PageSuccess>
            </WhatifWrapper>
        );
    }
}

export default BrandeProfileSuccess;
